import { BLOCK_CARDS_COUNT, WARNING_CARDS_COUNT } from '../constants';

import { TYPES } from './typings';

export const getDisplayType = (count: number, shouldShowWarning?: boolean): TYPES => {
    if (count >= BLOCK_CARDS_COUNT && shouldShowWarning) {
        return TYPES.BLOCK;
    }

    if (count >= WARNING_CARDS_COUNT && shouldShowWarning) {
        return TYPES.WARNING;
    }

    return TYPES.DEFAULT;
};
